import { InjectProperty } from '@jack-henry/frontend-utils/di';
import { DashboardService } from '@treasury/domain/dashboard';
import { TmBaseComponent } from '@treasury/presentation';
import { clockIcon } from '@treasury/presentation/assets/icons';
import '@treasury/presentation/components/tm-icon';
import '@treasury/presentation/components/tm-loader';
import { html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import '../../components/jhd-tooltip';

export const tagName = 'cutoff-times-header-item';
@customElement(tagName)
export class CutoffTimesHeaderItem extends TmBaseComponent {
    @property({ type: Boolean })
    public showCutoffTooltip = false;

    @state()
    private loading = false;

    @state()
    private cutoffTimes: {
        timeZone: string;
        cutoffTimes: { label: string; cutoffTime: string }[];
    } = { timeZone: '', cutoffTimes: [] };

    @InjectProperty()
    declare private readonly client: DashboardService;

    protected async firstUpdated() {
        this.loading = true;
        this.cutoffTimes = await this.client.getCutoffTimes();
        this.loading = false;
    }

    protected renderCutoffTimes() {
        const cutoffTimeList = this.cutoffTimes.cutoffTimes.map(
            (cutoffTime: { label: string; cutoffTime: string }) =>
                html`<div class="flex justify-between cutoff-time mt-1 text-header leading-6">
                    <span>${cutoffTime.label}</span>
                    <span>${cutoffTime.cutoffTime}</span>
                </div>`
        );
        return html`<div
                class="cutoff-header flex flex-row items-center pb-1 text-sm font-medium text-header border-b"
            >
                <span
                    ><tm-icon
                        class="relative top-0.5"
                        color="var(--secondary-text-color)"
                        .icon=${clockIcon}
                    ></tm-icon
                ></span>
                <span
                    >&nbsp;Cut-Off Times
                    <span class="cutoff-time-zone text-xs font-normal"
                        >${this.cutoffTimes.timeZone}</span
                    ></span
                >
            </div>
            ${cutoffTimeList}`;
    }

    protected render() {
        if (this.loading) {
            return html`<tm-loader reversed></tm-loader>`;
        }
        return html`<jhd-tooltip direction="bottom-left" light>
            <tm-icon color="var(--jh-color-gray-0)" .icon=${clockIcon}></tm-icon>
            <style>
                .tooltip-content {
                    width: 196px;
                    margin-top: -7px;
                }
            </style>
            <div class="tooltip-content" slot="content">${this.renderCutoffTimes()}</div>
        </jhd-tooltip>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: CutoffTimesHeaderItem;
    }
}
